import WebGL from 'three/addons/capabilities/WebGL.js';

export const supportsWebGL = () => WebGL.isWebGLAvailable();
